<!--
  File name: Alert.vue
  Program Description:
    - This component displays an alert in the system.
    - When accessed, it handles the message, image and/or email resend link
    to be prompted by an alert dialog when an action has been triggered.
-->

<template>
  <v-alert
    colored-border
    elevation="2"
    min-height="420"
    tile
    :class="show ? 'd-flex justify-center rounded-lg' : ''"
    :value="show"
    @input="$emit('update:show', false)"
  >
    <template v-slot:close="{ toggle }">
      <v-btn
        style="position:absolute; top:10px; right:10px;"
        icon
        @click="toggle"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </template>
    <v-card
      flat
      class="text-center py-10 px-1"
      max-width="270"
    >
      <template v-if="withImage">
        <v-row>
          <v-col class="pa-1">
            <v-img
              :src="images[type].image"
              width="100%"
              height="100%"
              contain
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2
              :style="`color: ${images[type].color}`"
              class="mb-1"
            >
              {{ images[type].label }}
            </h2>
          </v-col>
        </v-row>
      </template>
      <ul v-if="list && list.length">
        <li
          v-for="(item, idx) in list"
          :key="idx"
        >
          {{ item }}
        </li>
      </ul>
      <template v-else>
        {{ message }}
      </template>
      <template v-if="email">
        <v-spacer />
        <br>Didn't receive the link? <b
          style="cursor: pointer; color:#272a68;"
          @click="resend"
        >Resend Link</b>
        <v-progress-linear
          v-show="loading"
          indeterminate
        />
        <v-alert
          :value="resendAlert.alert"
          :type="resendAlert.type"
          transition="fade-transition"
          width="220"
        >
          {{ resendAlert.message }}
        </v-alert>
      </template>
    </v-card>
  </v-alert>
</template>

<script>
import password from '@/utils/webapi/password'
import error from '@/assets/error.png'
import success from '@/assets/success.png'
import signup from '@/assets/signup.png'
import clock from '@/assets/clock.png'
import draft from '@/assets/draft.png'
import deleted from '@/assets/deleted.png'
export default {
  name: 'Alert',
  props: {
    message: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'error'
    },
    withImage: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    images: {
      error: {
        image: error,
        label: 'Sorry!',
        color: '#A22929'
      },
      success: {
        image: success,
        label: 'Well done!',
        color: 'green'
      },
      signup: {
        image: signup,
        label: 'Thank you for Signing Up!',
        color: '#121F6B'
      },
      clock: {
        image: clock,
        label: 'Email has been sent!',
        color: '#121F6B'
      },
      draft: {
        image: draft,
        label: 'Saved as Draft!',
        color: '#121F6B'
      },
      delete: {
        image: deleted,
        label: 'Deleted!',
        color: '#A22929'
      },
      invalid: {
        image: deleted,
        label: 'Invalidated!',
        color: '#A22929'
      }
    },
    loading: false,
    resendAlert: {
      alert: false,
      type: 'success',
      message: 'Email has been sent!'
    }
  }),
  methods: {
    async resend () {
      this.loading = true
      const resp = await password.request.reset(this.email)
      this.resendAlert.alert = true
      if (!resp.ok) {
        this.resendAlert.type = 'error'
        this.resendAlert.message = (await resp.json()).error
      }
      this.loading = false
      window.setTimeout(() => {
        this.resendAlert.alert = false
      }, 3000)
    }
  }
}

</script>

<style scoped>
.v-alert {
  width: 400px;
}
</style>
